import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../../../language/keys';
import { ButtonIcon, Container } from './see-more-button.styled';

export const SeeMoreButton = ({ count, clickHandler }: SeeMoreButtonProps): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Container onClick={ clickHandler }>
      <ButtonIcon />
      { translate(count ? STRING_KEYS.SEE_X_MORE : STRING_KEYS.SEE_MORE, { count }) }
    </Container>
  );
};
